import { Component, OnInit ,ViewEncapsulation, Input, Output, Renderer2, Inject, NgZone, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/platform-browser';
import { SharedDataService } from 'app/shared-data.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-card-integration',
  templateUrl: './card-integration.component.html',
  styleUrls: ['./card-integration.component.scss'], 
  providers: [HttpClient],
  encapsulation: ViewEncapsulation.None,
})
export class CardIntegrationComponent implements OnInit {
    @Input() sessionID: any = null;
    @Input() OTP: any = null;
    @Output() paymentTriggered = new EventEmitter<any>();
    @Output() otpSubmitTriggered = new EventEmitter<any>();

    constructor(
        private renderer: Renderer2,
        private ngZone: NgZone,
        public sharedDataService: SharedDataService,
        @Inject(DOCUMENT) private _document
    ) { }

  submitClicked = false;
  async ngOnInit() {
    window['angularComponentReference'] = { 
        component: this, 
        zone: this.ngZone, 
        rerun: () => this.rerunScript(),
        loadAngularFunction: (response, issue) => this.integrationFunctionCalled(response, issue),
        submitting: () => this.submitting(),
        otpSubmitted: () => this.otpSubmitted(),
    };

    var scriptTag1 = document.getElementById('card-entry-1');
    if (scriptTag1) {
        scriptTag1.parentNode.removeChild(scriptTag1);
    }
    
    if (this.OTP) {
        await this.sharedDataService.delay(2000);
        let fullhtml = document.createElement('div');
        // fullhtml.style.height = '50vh';
        fullhtml.style.width = '100%';
        fullhtml.innerHTML = this.OTP.html;
        let noScripthtml:any = fullhtml;
        let iframeRef = noScripthtml.getElementsByTagName('iframe');
        // iframeRef[0].height = '50vh';
        
        
        

        var scriptElement = noScripthtml.querySelector("#authenticate-payer-script");
        var scriptContent:any;
        if (scriptElement) {
            scriptContent = scriptElement.innerHTML;
            

            scriptElement.parentNode.removeChild(scriptElement);
        }

        
        let otpdiv = document.getElementById('otpdiv');
        otpdiv.appendChild(noScripthtml);

        if (scriptContent) {
            const s = this.renderer.createElement('script');
            s.type = 'text/javascript';
            s.id = 'authenticate-payer-script';
            s.text = scriptContent;
            this.renderer.appendChild(this._document.body, s);
        }

        return;
    }
    const s = this.renderer.createElement('script');
    s.type = 'text/javascript';
    s.id = 'card-entry-1';
    s.src = window.location.href.includes('localhost') ? `https://eu-gateway.mastercard.com/form/version/72/merchant/TESTGTB100780B02/session.js` : `https://eu-gateway.mastercard.com/form/version/72/merchant/${environment.cardIntegrationMerchantID}/session.js`;
    s.text = ``;
    this.renderer.appendChild(this._document.body, s);

    var scriptTag = document.getElementById('card-entry-2');
    if (scriptTag) {
        scriptTag.parentNode.removeChild(scriptTag);
    }

    await this.sharedDataService.delay(1000);
    var scriptalive = document.getElementById('card-entry-1');
    

    if (!scriptalive) {
        this.sharedDataService.showSpinner();
        
        const s = this.renderer.createElement('script');
        s.type = 'text/javascript';
        s.id = 'card-entry-1';
        s.src = `https://eu-gateway.mastercard.com/form/version/72/merchant/${environment.cardIntegrationMerchantID}/session.js`;
        s.text = ``;
        this.renderer.appendChild(this._document.body, s);
        this.rerunScript('no need for spinner');
        return;
    }
    else{
        
    }
    
    const s2 = this.renderer.createElement('script');
    s2.id = 'card-entry-2';
    s2.text = `
    //   
      if (self === top) {
        // 
        var antiClickjack = document.getElementById("antiClickjack");
        // 
        if(antiClickjack){
          antiClickjack.parentNode.removeChild(antiClickjack);
        }
     } else {
        
        //  top.location = self.location;
     }

     try {
        PaymentSession.configure({
            session: '${this.sessionID}',
            fields: {
                // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
                card: {
                    number: "#card-number",
                    securityCode: "#security-code",
                    expiryMonth: "#expiry-month",
                    expiryYear: "#expiry-year",
                    nameOnCard: "#cardholder-name"
                }
            },
            //SPECIFY YOUR MITIGATION OPTION HERE
            frameEmbeddingMitigation: ["javascript"],
            callbacks: {
                initialized: function (response) {
                    // HANDLE INITIALIZATION RESPONSE
                },
                formSessionUpdate: function (response) {
                    // HANDLE RESPONSE FOR UPDATE SESSION
                    
                    if (response.status) {
                        if ("ok" == response.status) {
                            
    
                            //check if the security code was provided by the user
                            if (response.sourceOfFunds.provided.card.securityCode) {
                                
                            }
    
                            //check if the user entered a Mastercard credit card
                            if (response.sourceOfFunds.provided.card.scheme == 'MASTERCARD') {
                                
                            }
   
                            window.angularComponentReference.zone.run(() => { window.angularComponentReference.loadAngularFunction(response, 'none'); });
                        } else if ("fields_in_error" == response.status) {
                            
                            let wahala = 'unknown';
                            if (response.errors.cardNumber) {
                               
                               wahala = "Card Number Is Invalid Or Missing."
                            }
                            if (response.errors.expiryYear) {
                                
                                wahala = "Expiry Year Invalid Or Missing."
                            }
                            if (response.errors.expiryMonth) {
                                
                                wahala = "Expiry Month Is Invalid Or Missing."
                            }
                            if (response.errors.securityCode) {
                                
                                wahala = "Security Code Is Invalid."
                            }
       
                           window.angularComponentReference.zone.run(() => { window.angularComponentReference.loadAngularFunction(response, wahala); });  
   
                        } else if ("request_timeout" == response.status) {
                            
                            window.angularComponentReference.zone.run(() => { window.angularComponentReference.loadAngularFunction(response, 'Payment Session Timed Out'); });  
                        } else if ("system_error" == response.status) {
                            
                            window.angularComponentReference.zone.run(() => { window.angularComponentReference.loadAngularFunction(response, 'Payment Session Update Failed With System Error'); }); 
                        }
                    } else {
                        
                        window.angularComponentReference.zone.run(() => { window.angularComponentReference.loadAngularFunction(response, 'Payment Session Update Failed'); });  
                    }
                }
            },
            interaction: {
                displayControl: {
                    formatCard: "EMBOSSED",
                    invalidFieldCharacters: "REJECT"
                }
            }
        });
    
        function pay() {
            // UPDATE THE SESSION WITH THE INPUT FROM HOSTED FIELDS
            window.angularComponentReference.zone.run(() => { window.angularComponentReference.submitting(); });
            PaymentSession.updateSessionFromForm('card');
        }       
     } catch (error) {
        window.angularComponentReference.zone.run(() => { window.angularComponentReference.rerun(); });
     }

     `;
     this.renderer.appendChild(this._document.body, s2);
  }

  async rerunScript(hideSpinner?){
    if (!hideSpinner) {
        
        this.sharedDataService.showSpinner();
    }
    
    await this.sharedDataService.delay(5000);

    var scriptTag = document.getElementById('card-entry-2');
    if (scriptTag) {
        scriptTag.parentNode.removeChild(scriptTag);
    }

    await this.sharedDataService.delay(1000);
    const s2 = this.renderer.createElement('script');
    s2.id = 'card-entry-2';
    s2.text = `
    //   
      if (self === top) {
        // 
        var antiClickjack = document.getElementById("antiClickjack");
        // 
        if(antiClickjack){
          antiClickjack.parentNode.removeChild(antiClickjack);
        }
     } else {
        
        //  top.location = self.location;
     }

 
     PaymentSession.configure({
         session: '${this.sessionID}',
         fields: {
             // ATTACH HOSTED FIELDS TO YOUR PAYMENT PAGE FOR A CREDIT CARD
             card: {
                 number: "#card-number",
                 securityCode: "#security-code",
                 expiryMonth: "#expiry-month",
                 expiryYear: "#expiry-year",
                 nameOnCard: "#cardholder-name"
             }
         },
         //SPECIFY YOUR MITIGATION OPTION HERE
         frameEmbeddingMitigation: ["javascript"],
         callbacks: {
             initialized: function (response) {
                 // HANDLE INITIALIZATION RESPONSE
             },
             formSessionUpdate: function (response) {
                 // HANDLE RESPONSE FOR UPDATE SESSION
                 
                 if (response.status) {
                     if ("ok" == response.status) {
                         
 
                         //check if the security code was provided by the user
                         if (response.sourceOfFunds.provided.card.securityCode) {
                             
                         }
 
                         //check if the user entered a Mastercard credit card
                         if (response.sourceOfFunds.provided.card.scheme == 'MASTERCARD') {
                             
                         }

                         window.angularComponentReference.zone.run(() => { window.angularComponentReference.loadAngularFunction(response, 'none'); });
                     } else if ("fields_in_error" == response.status) {
                         
                         let wahala = 'unknown';
                         if (response.errors.cardNumber) {
                            
                            wahala = "Card Number Is Invalid Or Missing."
                         }
                         if (response.errors.expiryYear) {
                             
                             wahala = "Expiry Year Invalid Or Missing."
                         }
                         if (response.errors.expiryMonth) {
                             
                             wahala = "Expiry Month Is Invalid Or Missing."
                         }
                         if (response.errors.securityCode) {
                             
                             wahala = "Security Code Is Invalid."
                         }
    
                        window.angularComponentReference.zone.run(() => { window.angularComponentReference.loadAngularFunction(response, wahala); });  

                     } else if ("request_timeout" == response.status) {
                         
                         window.angularComponentReference.zone.run(() => { window.angularComponentReference.loadAngularFunction(response, 'Payment Session Timed Out'); });  
                     } else if ("system_error" == response.status) {
                         
                         window.angularComponentReference.zone.run(() => { window.angularComponentReference.loadAngularFunction(response, 'Payment Session Update Failed With System Error'); }); 
                     }
                 } else {
                     
                     window.angularComponentReference.zone.run(() => { window.angularComponentReference.loadAngularFunction(response, 'Payment Session Update Failed'); });  
                 }
             }
         },
         interaction: {
             displayControl: {
                 formatCard: "EMBOSSED",
                 invalidFieldCharacters: "REJECT"
             }
         }
     });
 
     function pay() {
         // UPDATE THE SESSION WITH THE INPUT FROM HOSTED FIELDS
         window.angularComponentReference.zone.run(() => { window.angularComponentReference.submitting(); });
         PaymentSession.updateSessionFromForm('card');
     }
     `;
     this.sharedDataService.closeSpinner();
    this.renderer.appendChild(this._document.body, s2);
  }

  integrationFunctionCalled(response, issue){
    response.issue = issue;
    
    this.submitClicked = false;
    this.paymentTriggered.emit(response);
  }

  submitting(){
    this.submitClicked = true;
    this.sharedDataService.celebrate('Please Wait...');
  }

  submitForm(){
    
  }

  otpSubmitted(){
    
    this.otpSubmitTriggered.emit('submitted');
  }

  ngAfterViewInit(){
    // let el = document.getElementById('pdetails');
    let otp = document.getElementById('otpdiv');
    // if (el) {
    //     el.scrollIntoView({ behavior: 'smooth', block: 'start' });        
    // }
    // else 
    if (otp) {
        otp.scrollIntoView({ behavior: 'smooth', block: 'start' });        
    }
  }

}


// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/services/date-time/card-integration/card-integration.component.ts